<div class="pos-relative dialogContainer">
  <div>
    <button
      (click)="close()"
      class="closeBtn pull-right"
      mat-button
      color="accent"
      [disabled]="isLoading"
      >
      <span class="icon-ic-close popup_close"></span>
    </button>
    @if (isPackageLevel()) {
      <p class="font-xl heading">Upload Folder</p>
    }
    @if (!isPackageLevel()) {
      <p class="font-xl heading">Upload Files/Folder</p>
    }
  </div>

  <div class="upload-info-section">
    <div >
      <span class="icon-ic-upload upload-icon-large"></span>
    </div>
    <p class="file-restrictions">
      Max file size is 2GB.
    </p>
    <div
      class="drag-drop-area"
      [class.drag-over]="isDragOver"
      [class.drag-drop-area--disabled]="isLoading"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      >
      <div class="drag-drop-actionContainer">
        <div class="drag-drop-buttonStack">
          <button class="upload-button" [disabled]="isLoading" (click)="onFileInputClick()">
            @if (isPackageLevel()) {
              <span class="icon-ic-new-folder upload-icon"></span>
              <span>Upload Folder</span>
            }
            @if (!isPackageLevel()) {
              <span class="icon-ic-upload upload-icon"></span>
              <span>Upload Files</span>
            }
          </button>
          @if (!isPackageLevel()) {
            <button class="upload-button secondary-upload-button" [disabled]="isLoading" (click)="onFolderInputClick()">
              <span class="icon-ic-new-folder upload-icon"></span>
              <span>Upload Folder</span>
            </button>
          }
        </div>
        @if (isPackageLevel()) {
          <span class="drag-drop-hint">or Drag and Drop Folder</span>
        }
        @if (!isPackageLevel()) {
          <span class="drag-drop-hint">or Drag and Drop Files/Folders</span>
        }
      </div>
    </div>

    <!-- Display selected files/folders outside the drag-drop area -->
    @if (pendingFiles.length > 0 || pendingEmptyFolders.length > 0) {
      <div class="selected-items">
        <div class="selected-items-header">
          <span class="selected-count">{{ getTotalItemsCount() }} item(s) selected</span>
          @if (getTotalSelectedSizeLabel()) {
            <span class="selected-size" [class.selected-size--exceeded]="exceedsMaxTotalSize()">{{ getTotalSelectedSizeLabel() }}</span>
          }
        </div>
        @if (exceedsMaxTotalSize()) {
          <div class="selected-size-warning">
            Total selected size exceeds the 2GB limit. Remove some files/folders to continue.
          </div>
        }
        <div class="selected-items-list">
          @for (item of getDisplayItems(); track item.key) {
            <div class="item" [style.padding-left.px]="item.depth * 16">
              <i [class]="item.type === 'folder' ? 'fa fa-folder-o item-icon' : 'fa fa-file-o item-icon'"></i>
              <span class="item-name" [title]="item.name">{{ item.name }}</span>
              <span class="item-actions">
                <span class="item-size">{{ item.sizeLabel }}</span>
                <button
                  type="button"
                  class="item-remove-button"
                  [disabled]="isLoading"
                  (click)="removeSelectedItem(item)"
                  aria-label="Remove selected item"
                >
                  <span class="icon-ic-delete color-link"></span>
                </button>
              </span>
            </div>
          }
        </div>
      </div>
    }
  </div>
    <div
        class="package-level-message"
        [class.package-level-message--compact]="pendingFiles.length > 0 || pendingEmptyFolders.length > 0"
      >
        Note: Empty Folders/ folder structures containing empty subfolders must be uploaded using Drag and Drop
      </div>
  <div class="actionButtonContainer" [class.package-level-footer]="isPackageLevel()">
    <div class="actionButtonRow">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        class="mat-button-wrapper p-20 m-20 button"
        [disabled]="isOkDisabled()"
        (click)="!isLoading && onOkClick()"
        >
        @if (isLoading) {
          <span style="display:flex;align-items:center;gap:6px">
            <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
            Uploading...
          </span>
        } @else {
          OK
        }
      </button>
      <button
        mat-button
        (click)="isLoading ? cancelUpload() : close()"
        color="primary"
        class="mat-button p-20 m-20 button"
        [disabled]="isLoading"
        >
        Cancel
      </button>
    </div>
  </div>

  <input
    type="file"
    class="file-input"
    hidden
    #fileInput
    id="upload-drag-and-drop-file-input"
    (change)="onFileSelected($event)"
    />
  </div>
